import { graphql } from '@/gql';
import type { AddSavedGroceryToCartMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const addSavedGroceryToCart = async ({
  savedGroceryId,
  email,
  isClearPreviousItems,
}: AddSavedGroceryToCartMutationVariables): Promise<string> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AddSavedGroceryToCart($savedGroceryId: Float!, $email: String!, $isClearPreviousItems: Boolean) {
        addSavedGroceryToCart(savedGroceryId: $savedGroceryId, email: $email, isClearPreviousItems: $isClearPreviousItems)
      }
    `),
    variables: {
      savedGroceryId,
      email,
      isClearPreviousItems,
    },
  });

  return response.data?.addSavedGroceryToCart!;
};
